import { Grid, Paper } from "@material-ui/core";
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import { EditFormOutput } from "features/Forms/FormOutput/EditFormOutput/EditFormOutput";
import FormFailure from "features/Forms/FormOutput/FormFailure";
import { formTypeLabels } from "features/Forms/formBuilder/formBuilderConsts";
import { useGetClientsQuery } from "features/clients/clientSlice";
import _ from "lodash";
import { customFormStyle } from "./style";
import CustomFormOutput from "../../Forms/FormOutput/CustomFormOutput";
import { useGetImageTypesQuery } from "../vehicleSlice";
import ShimmerLoader from "../../../components/ShimmerLoader/ShimmerLoader";
import { useGetLotsQuery } from "../../lots/lotSlice";

export const VehicleCustomForm = ({
    vehicle,
    formType,
    customFormResponse,
    isLoadingForm,
    mode = 'download',
    showFailuresOnly,
    setShowFailuresOnly,
    formLabel,
    activity
}) => {
    const classes = customFormStyle();
    let { data: imageTypes, error: imageTypesError, isLoading: isLoadingImageTypes } = useGetImageTypesQuery();
    let { data: clients, error: clientError, isLoading: isLoadingClients } = useGetClientsQuery(null);
    let { data: lots, error: lotsError, isLoading: isLoadingLots } = useGetLotsQuery();
    clients = clients || [];
    imageTypes = imageTypes || [];
    lots = lots || [];

    const isLoading = () => isLoadingForm || isLoadingImageTypes || isLoadingClients || isLoadingLots;

    const clientAccounts = _.flatten(clients?.map(c => c.clientAccounts));

    const isAnswerAFailure = (failureValues, value) => {
        if (Array.isArray(failureValues)) {
            return failureValues.find(v => v?.id == value?.id || v?.id == value?.value)?.isFailure;
        } else if (failureValues && typeof failureValues === 'object') {
            return (failureValues.id == value?.id || failureValues.id == value?.value) && value?.isFailure;
        }
        return false
    }

    const getIsFailure = (failureValues, value) => {
        if (Array.isArray(value))
            return value?.some(v => isAnswerAFailure(failureValues, v));
        return isAnswerAFailure(failureValues, value);
    }

    const lot = lots.find(l => l.id === customFormResponse?.lotId);

    return (
        <>
            {mode === 'edit' ? <EditFormOutput
                customFormResponse={customFormResponse}
                lotId={vehicle.lotId}
                formType={formType}
                showFailuresOnly={showFailuresOnly}
                setShowFailuresOnly={setShowFailuresOnly}
                getIsFailure={getIsFailure}
                activity={activity}
            />
                :
                <Paper variant='outlined' className={classes.reportContainer}>
                    <Grid container alignItems='center' justifyContent="space-between" style={{ padding: '1em', background: '#efefef' }}>
                        <Grid item>
                            <div>{`View ${formTypeLabels[formType]}`}</div>
                        </Grid>
                        <Authorize profile={permissionProfiles.FORMS.EDIT_FORM_RESPONSE}>
                            <Grid item>
                                <FormFailure customFormResponse={customFormResponse} showFailuresOnly={showFailuresOnly} setShowFailuresOnly={setShowFailuresOnly} />
                            </Grid>
                        </Authorize>
                    </Grid>

                    {
                        isLoading() ?
                            <ShimmerLoader count={5} height="100" />
                            :
                            <CustomFormOutput
                                vehicle={vehicle}
                                generatedDate={customFormResponse?.createdDate}
                                sections={customFormResponse?.form?.sections || []}
                                answers={customFormResponse?.answers || []}
                                imageTypes={imageTypes}
                                lot={lot}
                                formTypeLabel={`${formLabel ?? formTypeLabels[formType]} `}
                                showFailuresOnly={showFailuresOnly}
                                formType={formType}
                            />
                    }
                </Paper>}
        </>
    )
}